/*
 * Wraps SATComponent.prototype._hashFor and .applyHash to extend the site's
 * deep-link system past its original five pages (#manifest / #import /
 * #archives / #case-files / #case-file/<no>).
 *
 * Two gaps this closes:
 *
 * 1. A real bug in the original _hashFor / applyHash pair: every nav click
 *    into Era Archives sets state.page to 'archives' (see goArchives /
 *    navKeyArchives / the showArchives render check), but the original
 *    _hashFor's lookup table only recognizes the page name 'catalog', and
 *    applyHash's reverse map writes 'catalog' back for the #archives hash.
 *    Neither name is ever the other, so the address bar never actually
 *    updates to #archives while browsing there, and visiting #archives
 *    directly does not land on the Archives page either. That mismatch is
 *    the root cause of "linking always just shows southernairtrade.com."
 *
 * 2. No deep link ever existed for a specific era terminal or a specific
 *    catalog item — only the five top-level pages were addressable. Added:
 *      #archives/1970s            -> boots straight into that terminal
 *      #archives/1970s/<code>     -> boots in and opens that one record
 *      #archives/1980s[/<code>]   -> same, for the 1980s terminal
 *      #archives/1990s[/<code>]   -> same, for the 1990s terminal
 *      #archives/2000s[/<code>]   -> same, for the 2000s terminal
 *      #item/<code>               -> opens that product's detail modal
 *                                     from The Southern Air Import
 *    The Classified/Restricted terminal is deliberately left out of this —
 *    it stays behind its own clearance-code gate (see
 *    assets/sat-clearance-backdoor-patch.js); a deep link must not become a
 *    new way to skip that.
 *
 * Falls back to the original implementation for everything else, so
 * #manifest / #import / #case-files / #case-file/<no> keep working exactly
 * as before.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var proto = window.SATComponent.prototype;
  var origHashFor = proto._hashFor;
  var origApplyHash = proto.applyHash;

  // era name -> { open: catalog-only opener, item: opener(id, returnTo),
  // view: state.view values that belong to this era, active: the state key
  // holding the currently-open record's id, records: the this[...] map used
  // to check a record id is real before trying to open it }
  var ERA = {
    '1970s': { open: 'openCatalog70', item: 'open70',        views: ['list70', 'proj70', 'view70'], active: 'active70',    records: 'records70' },
    '1980s': { open: 'openCatalog80', item: 'openArchive80',  views: ['list80', 'boot80', 'term80'], active: 'activeRecord', records: 'records80' },
    '1990s': { open: 'openCatalog90', item: 'openArchive90',  views: ['list90', 'boot90', 'view90'], active: 'active90',    records: 'records90' },
    '2000s': { open: 'openCatalog00', item: 'openArchive00',  views: ['list00', 'boot00', 'view00'], active: 'active00',    records: 'records00' }
  };
  var VIEW_TO_ERA = {};
  Object.keys(ERA).forEach(function (era) {
    ERA[era].views.forEach(function (v) { VIEW_TO_ERA[v] = era; });
  });

  proto._hashFor = function (s) {
    if (s.page === 'store' && s.detailId) { return '#item/' + s.detailId; }

    var eraName = VIEW_TO_ERA[s.view];
    if (eraName) {
      var id = s[ERA[eraName].active];
      return id ? ('#archives/' + eraName + '/' + id) : ('#archives/' + eraName);
    }

    if (s.page === 'archives') { return '#archives'; }

    return origHashFor.call(this, s);
  };

  proto.applyHash = function () {
    var h = decodeURIComponent(location.hash || '');
    if (!h) { return; }

    var itemMatch = h.match(/^#item\/(.+)$/);
    if (itemMatch) {
      var code = itemMatch[1];
      if (this._products && this._products.some(function (p) { return p.id === code; })) {
        this.setState({ page: 'store', detailId: code });
      }
      return;
    }

    var eraMatch = h.match(/^#archives\/([^/]+)(?:\/(.+))?$/);
    if (eraMatch) {
      var eraName = eraMatch[1];
      var recordId = eraMatch[2];
      var cfg = ERA[eraName];
      if (cfg) {
        var records = this[cfg.records];
        if (recordId && records && records[recordId] && this[cfg.item]) {
          this[cfg.item](recordId, 'site');
        } else if (this[cfg.open]) {
          this[cfg.open]();
        }
        return;
      }
    }

    if (h === '#archives') { this.setState({ page: 'archives' }); return; }

    origApplyHash.call(this);
  };
})();
